import React from 'react';
import { useGetProduct } from '@app/sdk';

export default function CustomerProduct({ productId }: { productId: string }) {
  const { data: product } = useGetProduct({ productId });

  return <>{(product && product.description) || <div className="ui active small inline loader" />}</>;
}
